import { useEffect, useState } from "react";
import BriefingTable from "components/Briefing/subcomponents/table";

import { useSelector } from "react-redux";
import Actions from "components/Briefing/subcomponents/actions"; // Fixed typo (Actoins -> Actions)
import { quotingHeadTableAPI } from "../../Apis/Briefing";
import { TextField } from "components/Briefing/subcomponents/safety-subcomponents/fields";
import HistoryViewer from "components/Briefing/subcomponents/safety-subcomponents/historyViewer";
import toast from "react-hot-toast";
import { getFieldShiftFlag } from "../helpers";
import { SelectField } from "../subcomponents/safety-subcomponents/fields";

const QuotingBriefing = () => {
    const [data, setData] = useState([]);
    const [refresh, setRefresh] = useState(false);

    const briefing = useSelector((state) => state.briefing.line);
    const shift = useSelector((state) => state.shift);

    const archived = (briefing === "Old Briefings");

    const startDate = useSelector((state) => state.archiveSearch.startDate);
    const endDate = useSelector((state) => state.archiveSearch.endDate);
    const searchTerm = useSelector((state) => state.archiveSearch.searchTerm);

    function backendSync(id, changes) {
        return quotingHeadTableAPI.update(id, { ...changes, shift_flag: getFieldShiftFlag(shift) })
            .then(() => {
                setRefresh(!refresh);
            }
            )
    }

    useEffect(() => {
        (async () => {
            await new Promise(resolve => setTimeout(resolve, 500));
            if (archived) {
                const requestPayload = {
                    "startDate": startDate,
                    "endDate": endDate,
                    "searchTerm": searchTerm
                }
                const response = await quotingHeadTableAPI.getArchive(requestPayload); // Changed to truck API
                setData(response.data);
            }
            else {
                const response = await quotingHeadTableAPI.filter({
                    archived: false,
                    search_term: searchTerm,
                });
                setData(response.data);
            }
        })();
    }, [refresh, startDate, endDate, searchTerm, briefing]);

    const headers = [
        "ID",
        "Customer Set",
        "Notes",
        'Act.'
    ];

    const renderRow = (row) => (
        <>
            <tr key={`safety-truck-row-${row.id}`} className="safety-row">
                <td className="row-id-cell">
                    <div className="row-id-div">
                        {row.id}
                    </div>
                </td>
                <td style={{ width: "15%" }}>
                    <SelectField row={row} label={"customer_set"} options={["RXO", "US", "MX", "TL"]} onBackendSync={backendSync} />
                </td>
                <td>
                    <TextField row={row} label={"notes"} maxLength={500} onBackendSync={backendSync} />
                </td>
                <td className="actions-cell">
                    <Actions
                        onDelete={() => (
                            quotingHeadTableAPI.delete(row.id).then(() => { // Changed to truck API
                                setRefresh(!refresh);
                            }).catch((error) => {
                                console.error("Error deleting truck:", error); // Changed to "truck"
                                toast.error(error.response?.data?.msg || "An error occurred while deleting the truck."); // Changed to "truck"
                            })
                        )}
                        onArchive={() => (
                            quotingHeadTableAPI.update(row.id, { archived: true }).then(() => { // Changed to truck API
                                toast.success("Row archived successfully");
                                setRefresh(!refresh);
                            })
                            .catch((error) => {
                                console.error("Error archiving row:", error);
                                toast.error(error.response?.data?.msg || "An error occurred while archiving the row.");
                            })
                        )}
                    />
                </td>
            </tr>
            <tr className="safety-updated-at-row">
                <td colSpan={headers.length - 1} className="pt-0 pb-0">
                    <span className="input-updated-at-label">
                        Updated by: {row.updated_by ? row.updated_by : "Unknown"} {row.updated_at ? row.updated_at : "Never"}
                    </span>
                </td>
            </tr>
        </>
    );

    if (archived && !data.length) {
        return null
    }

    return (
        <>
            <div className="table-header">
                <h2>
                    Quoting
                </h2>
                <HistoryViewer
                    historyAPICall={quotingHeadTableAPI.getHistory}
                />
            </div>
            <BriefingTable
                headers={headers}
                rows={data}
                renderRow={renderRow}
                createRow={async () => {
                    await quotingHeadTableAPI.create({})
                    setRefresh(!refresh);
                }}
            />
        </>
    );
};

export default QuotingBriefing; // Changed component name to "TruckReports"
